import { useEffect } from 'react';

export default function usePdfAutoScale({
  numPages,
  containerRef,
  scaleCalculatedRef,
  originalPageWidthRef,
  baseScaleRef,
  manualZoom,
  zoomLevel,
  setPageScale,
  setZoomLevel,
  setZoomInputValue,
}) {
  useEffect(() => {
    if (!numPages || !containerRef.current) return;

    const calculateScale = () => {
      if (!containerRef.current) return;

      const containerWidth = containerRef.current.clientWidth;
      const containerHeight = containerRef.current.clientHeight;
      const isSmallScreen = typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

      if (containerWidth > 0 && containerHeight > 0 && scaleCalculatedRef.current && originalPageWidthRef.current) {
        const padding = 16;
        const availableWidth = isSmallScreen ? Math.max(window.innerWidth - padding, containerWidth - padding) : containerWidth - padding;
        const nextBaseScale = Math.min(availableWidth / originalPageWidthRef.current, 3.0);

        if (nextBaseScale > 0 && Math.abs(nextBaseScale - baseScaleRef.current) > 0.05) {
          baseScaleRef.current = nextBaseScale;

          if (!manualZoom) {
            setPageScale(nextBaseScale);
            setZoomLevel(100);
            setZoomInputValue('100');
          } else {
            const nextScale = nextBaseScale * (zoomLevel / 100);
            setPageScale(nextScale);
          }
        }
      }
    };

    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(calculateScale, 150);
    };

    handleResize();
    window.addEventListener('resize', handleResize);

    let resizeObserver;
    try {
      resizeObserver = new ResizeObserver(() => handleResize());
      resizeObserver.observe(containerRef.current);
    } catch {
      // noop
    }

    return () => {
      window.removeEventListener('resize', handleResize);
      try {
        resizeObserver?.disconnect();
      } catch {
        // noop
      }
      clearTimeout(resizeTimeout);
    };
  }, [
    baseScaleRef,
    containerRef,
    manualZoom,
    numPages,
    originalPageWidthRef,
    scaleCalculatedRef,
    setPageScale,
    setZoomInputValue,
    setZoomLevel,
    zoomLevel,
  ]);
}
